import { CategoryStateInterface } from "@/interface/categories/category.interface";
import ENDPOINTS from "@/providers/end-points";
import axios from "@/providers/requests";
import Category from "@/modules/category";

const state: CategoryStateInterface = {
  list: [],
  totalRows: 0,
  success: false,
  message: "",
  category: null,
};

const CategoriesStore = {
  namespaced: true,
  state,

  getters: {
    list: (state: any): Array<any> => state.list,
    totalRows: (state: any): number => state.totalRows,
    success: (state: any): boolean => state.success,
    message: (state: any): string => state.message,
    category: (state: any): string => state.category,
  },

  mutations: {
    SET_CATEGORY_CREATED(state: any, payload) {
      state.success = payload.success;
      state.message = payload.message || "";
    },
    SET_CATEGORY(state: any, payload) {
      state.category = payload;
    },
  },
  actions: {
    async createCategory({ commit }: { commit: any }, payload) {
      return await axios
        .post(ENDPOINTS.CREATE_CATEGORY, payload)
        .then((response) => response.data)
        .then(async (response) => {
          await commit("SET_CATEGORY_CREATED", { success: true });
        })
        .catch(async ({ error }) => {
          await commit("SET_CATEGORY_CREATED", { success: false, message: error.message || "Not saved yet" });
          await console.log(error);
        });
    },
    async getCategory({ commit }: { commit: any }, id) {
      return await axios
        .get(`${ENDPOINTS.GET_CATEGORY(id)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          const category: Object = new Category(data);
          await commit("SET_CATEGORY", category);
        })
        .catch(async (error) => {
          await commit("SET_CATEGORY", null);
          await console.log(error);
        });
    },
    async updateCategory({ commit }: { commit: any }, payload) {
      return await axios
        .put(`${ENDPOINTS.CREATE_CATEGORY}/${payload.id}`, payload)
        .then((response) => response.data)
        .then(async (response) => {
          await commit("SET_CATEGORY_CREATED", { success: true });
        })
        .catch(async ({ error }) => {
          await commit("SET_CATEGORY_CREATED", { success: false, message: error.message || "Not saved yet" });
          await console.log(error);
        });
    },
  },
};

export default CategoriesStore;
